module.exports = __webpack_public_path__ + "img/IT.cad8a8bf.svg";